import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as CustomFieldsEmployees from '../components';
import EmployeesListHandlers from './EmployeesListHandlers';
import EmployeesRowContainer from './EmployeesRowContainer';

import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';
import {
  getPagination,
  getFilters,
  getVisibleCustomFieldsEmployees,
  getIsLoading,
  getNeedFetch,
} from '../selectors';
import { toggle } from '../actions';
import { addGrowlError as error, addGrowlSuccess as success } from 'messages/actions';

class EmployeesListContainer extends PureComponent {
  static propTypes = {
    company: PropTypes.object.isRequired,
    subcompany: PropTypes.object.isRequired,
    pagination: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    permissions: PropTypes.object.isRequired,
  };
  handleToggle = (id) =>
    this.props
      .toggle(id, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => this.props.success(value.message))
      .catch((err) => this.props.error(err.message));

  render = () => (
    <EmployeesListHandlers
      render={({
        handleOrderChange,
        handleLimitChange,
        handlePageChange,
        handleFiltersChange,
        handleSubmit,
        columnSearch, // Cambiar por redux
        handleToggleSearch, // Agregar
      }) => (
        <CustomFieldsEmployees.ListView
          count={this.props.employees.length}
          filters={this.props.filters}
          company={this.props.company}
          isLoading={this.props.isLoading}
          handleOrderChange={handleOrderChange}
          handleToggle={this.handleToggle}
          handleSubmit={handleSubmit}
          handleFiltersChange={handleFiltersChange}
          handleToggleSearch={handleToggleSearch} // Agregar
          columnSearch={columnSearch} // Agregar - corregir por Redux
          handleLimitChange={handleLimitChange}
          handlePageChange={handlePageChange}
          subcompany={this.props.subcompany}
          pagination={this.props.pagination}
          permissions={this.props.permissions}
        >
          {this.props.employees.map((employee) => (
            <EmployeesRowContainer
              key={employee.id}
              employee={employee}
              handleToggle={this.handleToggle}
            />
          ))}
        </CustomFieldsEmployees.ListView>
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  pagination: getPagination(state),
  filters: getFilters(state),
  employees: getVisibleCustomFieldsEmployees(state),
  permissions: getPermissions(state),
  isLoading: getIsLoading(state),
  needFetch: getNeedFetch(state),
});
const mapDispatchToProps = { toggle, error, success };

export default connect(mapStateToProps, mapDispatchToProps)(EmployeesListContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/custom_fields_employees/containers/EmployeesListContainer.js